import MediaAssetsForm from './MediaAssetsForm';

export default MediaAssetsForm;
